import "../../pages/home/homePage.css";
import LogoCarousel from "./LogoCarousel";

const MediaPartners = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL!;
  return (
    <LogoCarousel
      title="In The Media"
      apiEndpoint="api/v1/media-fetch"
      backendUrl={backendUrl}
    />
  );
};

export default MediaPartners;
